import React, { Component } from 'react';

class VenueTriggerSlide extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentSlide: {},
      selectedValues: [],
      showNextBtn: true,
      showPrevBtn: false,
      isLastBtn: false,
      currentIndex: 0,
    };
  }

  render() {
    return (
      <div className="">
        <div style={{backgroundColor: '#fff'}}>
          <h2 className="text-uppercase">{`Get Best Quote from ${this.props.venue.name}`}</h2>
          <div style={{ background: 'var(--vm-primary-colour)', height: 5 }}/>
        </div>
        <div style={{ height: '100%' }}>
          <div style={{ height: `350px`, overflowX: 'hidden', overflowY: 'scroll' }}>
            <div>
              <div className="">
                <div className="col-lg-4 col-xs-12" style={{padding: '0px'}}>
                  <div className="non-mobile"
                  style={{ height: "420px", marginLeft: "153px"}}>
                  <img src={"https://cdn.venuemonk.com/images/newsliderform/new_slider_form_desktop2.jpg"} />
                  </div>
                  <div className="mobile"><img
                  src={"https://cdn.venuemonk.com/images/newsliderform/new_slider_form_mobile.jpg"}
                  style={{height: "100%", width: "100%"}} /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}



export default VenueTriggerSlide;

